// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-blog-post [placeholder]:empty:not(:focus):before {
  content: attr(placeholder);
  font-style: italic;
  color: #aaaaaa;
  cursor: text;
}
app-blog-post section .section-inner {
  text-align: left;
}
app-blog-post section .section-inner img {
  width: 100%;
}
app-blog-post section .section-inner h2 {
  font-size: 35px;
  line-height: 43px;
}
app-blog-post section .section-inner h2::after {
  display: none;
}
app-blog-post [contentEditable] {
  padding-left: 1px;
  border-radius: 5px;
}
app-blog-post [contentEditable]:focus {
  background-color: rgba(255, 255, 255, 0.089);
}
app-blog-post html-input {
  display: block;
  min-height: 50vh;
  text-align: left;
}
app-blog-post html-input ngx-monaco-editor {
  height: 100% !important;
}
app-blog-post .custom-content {
  display: none;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/modules/blog-editor/blog-editor.component.scss"],"names":[],"mappings":"AACI;EACI,0BAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AAAR;AAGI;EACI,gBAAA;AADR;AAGQ;EACI,WAAA;AADZ;AAIQ;EACI,eAAA;EACA,iBAAA;AAFZ;AAIY;EACI,aAAA;AAFhB;AAQI;EACI,iBAAA;EACA,kBAAA;AANR;AASI;EACI,4CAAA;AAPR;AAUI;EACI,cAAA;EACA,gBAAA;EACA,gBAAA;AARR;AAUQ;EACI,uBAAA;AARZ;AAYI;EACI,aAAA;AAVR","sourcesContent":["app-blog-post {\n    [placeholder]:empty:not(:focus):before {\n        content: attr(placeholder);\n        font-style: italic;\n        color: #aaaaaa;\n        cursor: text;\n    }\n\n    section .section-inner {\n        text-align: left;\n\n        img {\n            width: 100%;\n        }\n\n        h2 {\n            font-size: 35px;\n            line-height: 43px;\n\n            &::after {\n                display: none;\n            }\n        }\n    }\n\n\n    [contentEditable] {\n        padding-left: 1px;\n        border-radius: 5px;\n    }\n\n    [contentEditable]:focus {\n        background-color: rgba(255, 255, 255, 0.089);\n    }\n\n    html-input {\n        display: block;\n        min-height: 50vh;\n        text-align: left;\n\n        ngx-monaco-editor {\n            height: 100% !important;\n        }\n    }\n    \n    .custom-content {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
